import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {
    MonitorPianAttApiResponse, MonitorPianAttDettApiResponse, MonitorPianAttVsTimeReportApiResponse,
    MonitorRisorseApiResponse, MonitorTimeReportApiResponse, MonitorValVersOre, MonitorValVersOreApiResponse
} from "./types";
import {EmailForm} from "../reports/types";
import AxiosInstanceUpload from "../../components/AxiosUpload";
import * as Yup from "yup";
import {Buffer} from "buffer";
import {format} from "date-fns";
import {
    sortingParam,
    columnFiltersParamWithDateRange,
    columnFiltersParamWithDateRange2,
    sortingParam2
} from "../../common/Services";
import {mapJsonToVersOreDTOApiResponse, VersOreDTO} from "../gestversore/types";


const moment = require('moment')

export function useGetAllMonitorRisorse(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<MonitorRisorseApiResponse>({
        queryKey: [
                  'fetchMonitorRisorse',
                  JSON.stringify(columnFilters),   // ensures deep change detection
                  globalFilter,
                  pagination.pageIndex,
                  pagination.pageSize,
                  JSON.stringify(sorting),
        ],
        queryFn: async () => {

            const idazienda = localStorage.getItem('keyidazienda') || '';

            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;


            let myURL = `?limit=${pagination.pageSize}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange(
                columnFilters,
                ''
            )}&ordering=${sortingParam(sorting, '')}`;

            myURL += `&CODDITTA=${idazienda}`;

            const response = await AxiosInstance.get(`monitorrisorse/${myURL}`);

            return response.data;
        },
        refetchOnWindowFocus: false,
    });
}


// export function useGetVersOreByProgNodo(codprog: string, codnodo: string) {
//   return useQuery<{ results: VersOreDTO[]; count: number }>({
//     queryKey: ['fetchVersOreByProgNodo', codprog, codnodo],
//     queryFn: async () => {
//   const response = await AxiosInstance.get(
//     `versoredto/?limit=1000&offset=0&VBT00_CODPROG=${codprog}&VBT00_CODNODO=${codnodo}`
//   );
//
//             return mapJsonToVersOreDTOApiResponse(response.data);
//         },
//         refetchOnWindowFocus: false,
//     });
// }
//
//
//
// export function useSendEmail() {
//   return useMutation({
//     mutationFn: async (emailForm: EmailForm) => {
//       return AxiosInstance.post('sendemail/', emailForm);
//     },
//   });
// }

export function useUploadReport() {
  return useMutation({
    mutationFn: async (formData: FormData) => {
      return AxiosInstanceUpload.post('uploadreport/', formData);
    },
  });
}

export function useGetAllMonitorTimeReport(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<MonitorTimeReportApiResponse>({
        queryKey: [
                  'fetchMonitorMonitorTimeReport',
                  JSON.stringify(columnFilters),   // ensures deep change detection
                  globalFilter,
                  pagination.pageIndex,
                  pagination.pageSize,
                  JSON.stringify(sorting),
        ],
        queryFn: async () => {

            const idazienda = localStorage.getItem('keyidazienda') || '';

            // const myOffset =
            //     pagination.pageIndex === 0
            //         ? '0'
            //         : `${pagination.pageSize * pagination.pageIndex}`;


            let myURL = `?limit=1000000&offset=0&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange2(
                columnFilters      
            )}&ordering=${sortingParam2(sorting)}`;

            myURL += `&ditta=${idazienda}`;

            const response = await AxiosInstance.get(`monitortimereport/${myURL}`);

            return response.data;
        },
        refetchOnWindowFocus: false,
    });
}

export function useGetAllMonitorPianAtt(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<MonitorPianAttApiResponse>({
        queryKey: [
                  'fetchMonitorMonitorPianAtt',
                  JSON.stringify(columnFilters),   // ensures deep change detection
                  globalFilter,
                  pagination.pageIndex,
                  pagination.pageSize,
                  JSON.stringify(sorting),
        ],
        queryFn: async () => {

            const idazienda = localStorage.getItem('keyidazienda') || '';

            // const myOffset =
            //     pagination.pageIndex === 0
            //         ? '0'
            //         : `${pagination.pageSize * pagination.pageIndex}`;


            let myURL = `?limit=1000000&offset=0&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange2(
                columnFilters      
            )}&ordering=${sortingParam2(sorting)}`;

            myURL += `&ditta=${idazienda}`;

            const response = await AxiosInstance.get(`monitorpianatt/${myURL}`);

            return response.data;
        },
        refetchOnWindowFocus: false,
    });
}


export function useGetAllMonitorPianAttVsTimeReport(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<MonitorPianAttVsTimeReportApiResponse>({
        queryKey: [
                  'fetchMonitorPianAttVsTimeReport',
                  JSON.stringify(columnFilters),   // ensures deep change detection
                  globalFilter,
                  pagination.pageIndex,
                  pagination.pageSize,
                  JSON.stringify(sorting),
        ],
        queryFn: async () => {

            const idazienda = localStorage.getItem('keyidazienda') || '';

            // const myOffset =
            //     pagination.pageIndex === 0
            //         ? '0'
            //         : `${pagination.pageSize * pagination.pageIndex}`;


            let myURL = `?limit=1000000&offset=0&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange2(
                columnFilters      
            )}&ordering=${sortingParam2(sorting)}`;

            myURL += `&ditta=${idazienda}`;

            const response = await AxiosInstance.get(`monitorpianattvstimereport/${myURL}`);

            return response.data;
        },
        refetchOnWindowFocus: false,
    });
}




export function useGetAllMonitorValVersOre(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<MonitorValVersOreApiResponse>({
        queryKey: [
                  'fetchMonitorValVersOre',
                  JSON.stringify(columnFilters),   // ensures deep change detection
                  globalFilter,
                  pagination.pageIndex,
                  pagination.pageSize,
                  JSON.stringify(sorting),
        ],
        queryFn: async () => {

            // const idazienda = localStorage.getItem('keyidazienda') || '';

            // const myOffset =
            //     pagination.pageIndex === 0
            //         ? '0'
            //         : `${pagination.pageSize * pagination.pageIndex}`;


            let myURL = `?limit=1000000&offset=0&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange2(
                columnFilters      
            )}&ordering=${sortingParam2(sorting)}`;

            // myURL += `&ditta=${idazienda}`;

            myURL += `&emailclientetimereport__isnull=false`;

            const response = await AxiosInstance.get(`monitorvalversore/${myURL}`);

            return response.data;
        },
        refetchOnWindowFocus: false,
    });
}





export function useGetMonitorPianAttDettByDipAndData(coddip: string, datareg: string) {
  return useQuery<{ results: VersOreDTO[]; count: number }>({
    queryKey: ['fetchVersOreByDipAndData', coddip, datareg],
    queryFn: async () => {
  const response = await AxiosInstance.get(
    `monitorpianattdett/?limit=1000000&offset=0&coddip_exact=${coddip}&datareg_exact=${datareg}&ditta_exact=2`
  );

            return response.data;
        },
        refetchOnWindowFocus: false,
    });
}


export function useGetVersOreByDipAndData(coddip: string, datareg: string) {
  return useQuery<{ results: VersOreDTO[]; count: number }>({
    queryKey: ['fetchVersOreByDipAndData', coddip, datareg],
    queryFn: async () => {
  const response = await AxiosInstance.get(
    `versoredto/?limit=1000000&offset=0&VBT00_CODDIP_exact=${coddip}&VBT00_DATAREG_exact=${datareg}&VBT00_DESDITTA=BS`
  );

            return mapJsonToVersOreDTOApiResponse(response.data);
        },
        refetchOnWindowFocus: false,
    });
}

export const validationSchema = Yup.object().shape({
                      fromDate: Yup.date().required('Selezione Data Inizio'),
                      toDate: Yup.date().test('is-after-or-equal', 'La data di fine deve essere successiva alla data di inizio', function (value) {
                                         const { fromDate } = this.parent; // Access fromDate from parent object
                                         if (!fromDate || !value) {
                                         return true; // Skip validation if fromDate or toDate is not set
                                      }
                                      return fromDate <= value; // Validate if toDate is after or equal to fromDate
                                    }),
                      emailTo: Yup.string().email('Email non è valida'),
                      idcli:  Yup.string().required('Seleziona Cliente'),
                      ditta:  Yup.string().required('Seleziona Ditta'),
                    });




